import { isNativeApp } from './platform'

const LANGUAGES = new Set(['fr', 'de', 'it', 'en'])
const APP_HOSTS = new Set(['app.hubbing.ch', 'localhost', '127.0.0.1', '[::1]'])

export function normalizeCompanyUid(value) {
  if (typeof value !== 'string' || value.length > 40) return null
  const compact = value.trim().toUpperCase().replace(/\s/g, '')
  if (!/^(CHE-?)?[1-9][0-9]{2}([.-]?[0-9]{3}){2}$/.test(compact)) return null
  const digits = compact.replace(/[^0-9]/g, '')
  const weights = [5, 4, 3, 2, 7, 6, 5, 4]
  const sum = weights.reduce((total, weight, index) => total + weight * Number(digits[index]), 0)
  const check = (11 - sum % 11) % 11
  return check !== 10 && check === Number(digits[8]) ? `CHE${digits}` : null
}

export function companyZefixUrl(companyOrUid, lang = 'fr') {
  const uid = normalizeCompanyUid(typeof companyOrUid === 'string' ? companyOrUid : companyOrUid?.zefix_uid)
  if (!uid) return null
  const language = LANGUAGES.has(lang) ? lang : 'fr'
  // Zefix resolves this exact UID search to its own internal firm identifier.
  // A Hubbing company id, CH-ID or UID must never be used as that identifier.
  const url = new URL(`https://www.zefix.admin.ch/${language}/search/entity/list`)
  url.search = new URLSearchParams({ name: uid, searchTypeExact: 'true' }).toString()
  return url.href
}

export function registryLinkEnabled(hostname = typeof window !== 'undefined' ? window.location.hostname : '', native = isNativeApp()) {
  return !native && APP_HOSTS.has(String(hostname).toLowerCase())
}

export function canViewRegistryLink(plan) {
  return ['basic', 'premium'].includes(String(plan || '').toLowerCase())
}
